module.exports = __webpack_public_path__ + "media/images/svgs/menu-e9901da20d432794123af6a5cab3e198.svg";